import React from 'react'
import './Navbar.scss'
import cx from 'classnames'
import {useScrolled} from '../../../hooks/scrolled.hook'
import {Link} from 'gatsby'
import {navbarData} from './Navbar.data'

const Navbar = ({close, toggle, romana}: NavbarProps) => {
    const isScrolled = useScrolled()
    const navbar = navbarData(romana)

    return <>
        <nav id="navbar" className={cx('navbar', {'scrolled': isScrolled})}>
            <div className='logo'>
                <img src={navbar.logo} alt="Logo" onClick={close}/>
            </div>
            <div className='nav-links'>
                {navbar.labels.map((label, index) =>
                    <a key={index} href={label.link}
                       className="nav-link">{romana ? label['ro'] : label['de']}</a>
                )}
                <Link to={romana ? '/de/' : '/ro/'} key="translation"
                      className="nav-link translation">{romana ? 'DE' : 'RO'}</Link>
            </div>
            <Link to={romana ? '/de/' : '/ro/'} key="translation"
                  className="nav-link translation translation-mobile">{romana ? 'DE' : 'RO'}</Link>
            <div className='menu-toggle' onClick={toggle}>☰</div>
        </nav>
    </>
}

interface NavbarProps {
    close: any
    toggle: any
    romana: boolean
}

export default Navbar
